import React from 'react';
import { css } from '@emotion/core';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import UnderscoreDivider from './UnderscoreDivider';
import { Subtitle, DisplayHeader } from './Typography';
import { Plus as UnstyledPlus } from './UiIcons';

const Plus = styled(UnstyledPlus)``;
/*
  In order to use a Component ref as a css selector, it must first be
  converted into an Emotion component.
*/

const RoleHeroCSS = css`
  margin-left: auto;
  margin-right: auto;
  text-align: center;

  ${DisplayHeader} {
    margin: 0 3rem;
  }

  ${Plus},
  ${UnderscoreDivider},
  ${Subtitle} {
    flex-shrink: 0;
    display: block;
    margin: 2rem auto;
  }
`;

const titleWrapperCSS = css`
  margin-top: 3rem;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  ${Plus} {
    margin: 0 auto;
  }
`;

const RoleHero = ({ name, description }) => (
  <div css={RoleHeroCSS} className="col-sm col-md-8 col-lg-6">
    <div css={titleWrapperCSS}>
      <Plus />
      <DisplayHeader>
        {name}
      </DisplayHeader>
      <Plus />
    </div>
    <UnderscoreDivider />
    <Subtitle>
      {description}
    </Subtitle>
    <Plus />
  </div>
);

RoleHero.propTypes = {
  name: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
};

export default RoleHero;
